var productBoxes = document.querySelectorAll('ul.productgrid--items li.productgrid--item');
// let scrollCount = 0;



function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 120 &&
        rect.bottom + 120 <= (window.innerHeight || document.documentElement.clientHeight)

    );
}


document.addEventListener('scroll', function () {

    if (window.screen.width) {
        // scrollCount++;

        // if (scrollCount >= 100){
        //     productBoxes = document.querySelectorAll('ul.productgrid--items li.productgrid--item');
        //     scrollCount = 0;
        // }

        productBoxes.forEach(box => {
            if (isInViewport(box) && !box.classList.contains('auto-addtocart-pop-in')){
                box.classList.add('auto-addtocart-pop-in');
            } else if (!isInViewport(box) && box.classList.contains('auto-addtocart-pop-in')){
                box.classList.remove('auto-addtocart-pop-in');
            }
        });
    }


}, {
    passive: true
});

